import { SoundEnum } from '@matap/shared';

export const sounds: { [key in SoundEnum]: any } = {
  [SoundEnum.DIAL_TONE]: require('./dial_tone.mp3'),
  [SoundEnum.RINGING]: require('./ringing.mp3'),
  [SoundEnum.QUEUE_TONE]: require('./queue_tone.mp3'),
  [SoundEnum.VISIT_TIME_ENDED]: require('./visit_time_ended.mp3'),
  [SoundEnum.VISIT_STARTED]: require('./visit_started.mp3'),
  [SoundEnum.NEW_PATIENT]: require('./new_patient.mp3'),
  [SoundEnum.DEFAULT_NOTIFICATION]: require('./default_notification.mp3'),
};
